

export const SET_DIALOG_HISTORY = "SET_DIALOG_HISTORY";


export function setDialogHistory(history: any) {
    return {
        type: SET_DIALOG_HISTORY,
        payload: history
    }
}